import { render, staticRenderFns } from "./ClmResCat.vue?vue&type=template&id=20189dcf&"
import script from "./ClmResCat.vue?vue&type=script&lang=js&"
export * from "./ClmResCat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports